import React, { useCallback, useEffect } from "react";
import { useAppConfig } from "../../../hooks/useAppConfig";

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { themeColors } = useAppConfig();

  const getMutedColor = useCallback(
    (color: string, opacity: number = 0.5): string => {
      const c = color.replace("#", "");
      const r = parseInt(c.slice(0, 2), 16);
      const g = parseInt(c.slice(2, 4), 16);
      const b = parseInt(c.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    },
    [],
  );

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--primary-btn-color", themeColors.btnColor);
    root.style.setProperty("--primary-text-color", themeColors.textColor);
    root.style.setProperty(
      "--primary-btn-text-color",
      themeColors.btnTextColor,
    );
    root.style.setProperty("--primary-bg-color", themeColors.bgColor);
    root.style.setProperty(
      "--primary-btn-text-color-muted",
      getMutedColor(themeColors.btnTextColor, 0.6),
    );
    root.style.setProperty(
      "--primary-btn-color-muted",
      getMutedColor(themeColors.btnColor, 0.6),
    );
    root.style.setProperty(
      "--primary-btn-color-muted-hover",
      getMutedColor(themeColors.btnColor, 0.1),
    );
    root.style.setProperty(
      "--primary-text-color-muted",
      getMutedColor(themeColors.textColor, 0.6),
    );
    root.style.setProperty(
      "--form-label-color",
      getMutedColor(themeColors.btnColor, 0.99),
    );
  }, [themeColors, getMutedColor]);

  return <>{children}</>;
};
